import React from "react";

const GlobalTVAction = () => {
    const handleOpenTV = () => {
        // Open the TV display page in a new blank tab
        window.open("/kiosk/tv", "_blank");
    };

    return (
        <div className="dropdown d-inline-block me-1">
            <button 
                type="button" 
                className="btn header-item noti-icon waves-effect"
                onClick={handleOpenTV}
                title="Abrir Painel da TV"
            >
                <i className="mdi mdi-television text-white" style={{ fontSize: '24px' }}></i>
            </button>
        </div>
    );
};

export default GlobalTVAction;
